module.exports = __webpack_public_path__ + "img/group-info-separate.0b4ebf18.png";